import { useQuery } from '@tanstack/react-query';

import { loadEmailDelivery } from './requests';

export const getEmailDeliveryQueryKey = (actionId?: string) => ['email-delivery', actionId];

export const useEmailDelivery = (actionId?: string) => {
  return useQuery({
    queryKey: getEmailDeliveryQueryKey(actionId),
    queryFn: () => loadEmailDelivery(actionId!),
    enabled: Boolean(actionId),
  });
};
